// examService

import api from '../api/api';
import { Exam, ExamCreate, ExamUpdate } from '../types';

// Get exams by class level
export const getExamsByClassLevel = async (classLevel: string, schoolId: number): Promise<Exam[]> => {
  const response = await api.get(`/exams/class-level/${classLevel}`, {
    params: { school_id: schoolId }
  });
  return response.data as Exam[];
};

// Get exams by school
export const getExams = async (classLevel?: string, schoolId?: number): Promise<Exam[]> => {
  const params: any = {};
  if (classLevel) params.class_level = classLevel;
  if (schoolId) params.school_id = schoolId;
  
  const response = await api.get('/exams/', { params });
  return response.data as Exam[];
};

// Get single exam
export const getExam = async (examId: number): Promise<Exam> => {
  const response = await api.get(`/exams/${examId}`);
  return response.data as Exam;
};

// Create exam
export const createExam = async (examData: ExamCreate): Promise<Exam> => {
  const response = await api.post('/exams', examData);
  return response.data as Exam;
};

// Update exam
export const updateExam = async (examId: number, examData: ExamUpdate): Promise<Exam> => {
  const response = await api.put(`/exams/${examId}`, examData);
  return response.data as Exam;
};

// Delete exam
export const deleteExam = async (examId: number): Promise<void> => {
  await api.delete(`/exams/${examId}`);
};

export const getActiveExamsByCourse = async (courseId: number): Promise<Exam[]> => {
  const response = await api.get(`/exams/course/${courseId}/active`);
  return response.data as Exam[];
};

// Exam Creator Wizard
export const createExamsWizard = async (examData: any): Promise<any> => {
  const response = await api.post('/exams/wizard/create', examData);
  return response.data;
};

// Create exams for all class levels
export const createExamsForAllClassLevels = async (examData: any): Promise<any> => {
  const response = await api.post('/exams/wizard/create-all', examData);
  return response.data;
};

// Bulk Operations
export const checkExamsWithGrades = async (examIds: number[]): Promise<number[]> => {
  const examIdsString = examIds.join(',');
  const response = await api.get('/exams/bulk/check-grades', { 
    params: { exam_ids: examIdsString } 
  });
  return response.data as number[];
};

export const bulkDeleteExams = async (examIds: number[]): Promise<void> => {
  await api.delete('/exams/bulk', { 
    headers: { 'Content-Type': 'application/json' },
    data: { exam_ids: examIds } 
  } as any);
};

export const bulkUpdateExamStatus = async (examIds: number[], isActive: boolean): Promise<Exam[]> => {
  const response = await api.patch('/exams/bulk/status', {
    exam_ids: examIds,
    is_active: isActive
  });
  return response.data as Exam[];
};

export const bulkUpdateExams = async (examIds: number[], updateData: any): Promise<Exam[]> => {
  const response = await api.patch('/exams/bulk', {
    exam_ids: examIds,
    ...updateData
  });
  return response.data as Exam[];
}; 